// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1K-wC","approved":"Status_approved__2E4hB","rejected":"Status_rejected__2Ex3n","expired":"Status_expired__2SNdz","label":"Status_label__342Ri"};